import styled from 'styled-components'
import {media, ButtonPrimary, Col} from '@modifi/ui'
import {darkGray, semiDarkGray, white} from '@modifi/colors'
import {RegionIcon} from '../../../../../assets/icons'

export const StyledLabelRadio = styled.div`
  min-height: 32px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: ${semiDarkGray};
`

export const ApplyButton = styled(ButtonPrimary)`
  width: 100%;
  margin-top: 16px;
`

export const DropdownWrapper = styled.div`
  padding: 16px 0;
  position: relative;
`

export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
`

type LRDropdownProps = {
  isOpen: boolean
  isHamburger: boolean
}
export const LRDropdown = styled.div<LRDropdownProps>`
  ${({isHamburger}): string => (isHamburger ? '' : 'margin-top: 16px;')}
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  ${({isHamburger}): string =>
    isHamburger ? '' : 'box-shadow: 3px 4px 16px rgba(23, 61, 108, 0.12);'}
  border-radius: 6px;
  padding: ${({isOpen}): string => (isOpen ? '16px' : '0')};
  ${({isHamburger}): string => (isHamburger ? '' : 'position: absolute;')}
  ${({isHamburger}): string => (isHamburger ? '' : 'right: 0;')}
  background-color: ${white};
  transition: max-height 0.3s, padding 0.4s;
  max-height: ${({isOpen}): string => (isOpen ? ' 600px' : '0')};
  overflow: hidden;
  z-index: 10000;
  max-width: 400px;
  ${media.md`
    width: 400px;
  `}

  > div {
    flex-wrap: nowrap;
  }

  h4 {
    color: ${darkGray};
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 0;
    margin-bottom: 8px;
  }
`

export const RegionIconWithMR = styled(RegionIcon)`
  margin-right: 8px;
`

export const StyledCol = styled(Col)`
  ${media.xs`
    padding: 0;
  `}
`
